export default "__VITE_ASSET__CjoNKGAV__"